import React, { useMemo, cloneElement } from 'react';
import { useSelector } from 'react-redux';

function PermissionCheck(props) {
  const { requiredRole, children, fallback, override, hiddenPermission } =
    props;

  const { data, success } = useSelector(state => state.user.Permissions);

  const { IsSysAdmin } = useSelector(state => state.user.user.details);

  const show = useMemo(() => {
    if (success && IsSysAdmin) {
      return true;
    }

    const hasPermission = data.Permissions.some(
      permission => permission.Name === requiredRole
    );

    return hiddenPermission ? !hasPermission : hasPermission;
  }, [success, hiddenPermission]);

  if (override) {
    let childOverrideProps = {};
    if (!show) {
      childOverrideProps = {
        onClick: () => {},
        href: undefined,
        style: { userSelect: 'none', cursor: 'default' }
      };
    }
    return cloneElement(children, childOverrideProps);
  }
  return show ? children : fallback ? fallback : <></>;
}

export default PermissionCheck;
